// extracted by mini-css-extract-plugin
var _1 = "ToolbarHighlightButton-module__active--w1_tr";
var _2 = "ToolbarHighlightButton-module__animatedBackground--MHHue";
var _3 = "ToolbarHighlightButton-module__blue--DrqSD";
var _4 = "ToolbarHighlightButton-module__green--v4JjR";
var _5 = "ToolbarHighlightButton-module__highlightIcon--CBvyp";
var _6 = "ToolbarHighlightButton-module__highlightMenu--BakAn";
var _7 = "ToolbarHighlightButton-module__red--tb4kF";
var _8 = "ToolbarHighlightButton-module__yellow--RnqeI";
export { _1 as "active", _2 as "animatedBackground", _3 as "blue", _4 as "green", _5 as "highlightIcon", _6 as "highlightMenu", _7 as "red", _8 as "yellow" }
